<img src="assets/Forbundspartner_500x500_black_ny.png" class="logo" alt="Logo">
<a href="mailto:post@forbundspartner.no" target="_blank" class="contact">post@forbundspartner.no</a>
